import { render } from "./NavBarPublic.vue?vue&type=template&id=05efa032&scoped=true"
import script from "./NavBarPublic.vue?vue&type=script&lang=js"
export * from "./NavBarPublic.vue?vue&type=script&lang=js"

import "./NavBarPublic.vue?vue&type=style&index=0&id=05efa032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05efa032"]])

export default __exports__